import { IApiStatusInitialState } from "../../types/apiStatusInterface";
import { ApiStatus, ApiStatusActionType } from "../actionTypes/apiStatusActionTypes";

const initialState: IApiStatusInitialState = {
  isPostSuccess: false,
  isPutSuccess: false,
};

export default function apiReducer(state = initialState, action: ApiStatusActionType) {
  switch (action.type) {
    case ApiStatus.SET_POST_API_STATUS:
      return {
        ...state,
        isPostSuccess: action.payload,
      };

    case ApiStatus.SET_PUT_API_STATUS:
      return {
        ...state,
        isPutSuccess: action.payload,
      };

    default:
      return state;
  }
}
